<template>
  <div>
    <div class="main-layout container">
      <DynamicWidgets :key="isLoggedIn" />
    </div>
    <LazyHydrate when-idle>
      <RegisterBonusBanner />
    </LazyHydrate>
    <div class="bottom container">
      <slot name="seo" />
      <slot />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LazyHydrate from 'vue-lazy-hydration'
import DynamicWidgets from '@/components/Home/DynamicWidgets'

const RegisterBonusBanner = () => import('@/components/Home/RegisterBonusBanner')

export default {
  name: 'MainLayout',
  components: {
    LazyHydrate,
    DynamicWidgets,
    RegisterBonusBanner,
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
